import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DetailLogMerchant from '../../components/fragments/DetailLogMerchant';
import { AppContext } from '../../contexts';
import { fetchLogSyncMerchantDetail } from './actions';
import ErrorHandler from '../../components/elements/ErrorHandler';

function DetailMerchant(){
  const { id } = useParams();
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const { data, loading, message, success } = useSelector((state) => state.logsSyncMerchant.detail);
  useEffect(() => {
    setBreadcrumbs([
      { name: 'Log Sinkronisasi Data Pangkalan', to: '/merchant/sinkronisasi-merchant' },
      'Detail']);
  }, []);

  useEffect(() => {
    dispatch(fetchLogSyncMerchantDetail(id));
  }, [id]);


  if (message && !success) {
    return <ErrorHandler message={message} />;
  }

  return (
    <div>
      <DetailLogMerchant data={data} loading={loading} />
    </div>
  );
}

export default DetailMerchant;
